"use client";

import React from "react";

import BackButton from "@/components/back-button";

interface PageLayoutProps {
  children: React.ReactNode;
  showBackButton?: boolean;
}

export function PageLayout({
  children,
  showBackButton = true,
}: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {showBackButton && (
        <div className="sticky top-0 z-40 border-b border-edge bg-background/80 backdrop-blur-sm">
          <div className="container mx-auto px-4 py-3">
            <BackButton />
          </div>
        </div>
      )}
      <main className="pb-16">{children}</main>
    </div>
  );
}
